<script setup lang="ts">
import OpportunityTooltip from '~/components/influencer/profile/about/activity/OpportunityTooltip.vue'
import IconDescriptionElement from '~/components/ui/Sections/IconDescriptionElement.vue'

type Props = {
  value: number
}

const props = defineProps<Props>()

const formattedValue = computed<number>(() => {
  const trueValue = Math.ceil(props.value * 100)

  return trueValue === 0 ? 1 : trueValue
})
</script>

<template>
  <IconDescriptionElement icon-class="icon fas fa-chart-pie">
    <template #title>
      {{ formattedValue }}%
      {{ $t('influencer.profile.slug.about.opportunityRate') }}
      <OpportunityTooltip />
    </template>
    <template #subtitle>{{
      $t('influencer.profile.slug.about.last12months')
    }}</template>
  </IconDescriptionElement>
</template>
